module.exports = __webpack_public_path__ + "static/content-04-80c433bc77e340eba373aa6ef87e394d.jpg";